import styled, { createGlobalStyle, css } from 'styled-components';
import { BasicMenuCss } from '../styles';
import { UserType } from '@asset/enum/UserEnum';
import { getActiveElementBackground, getHoveredElementBackground } from '../globalsStyles';
import { CHAT_ROOM_Z_INDEX, CHAT_ROOM_REM_WIDTH } from 'constants/chat';
const ChatRoomHeaderRemWidth = 4;
const messageBlueColor = 'var(--blue-95)';
const messageGrayColor = 'var(--gray-90)';
export const ChatGlobalStyle = createGlobalStyle(["[class*=sendbird-label]{font-family:Pretendard,sans-serif,'Apple SD Gothic Neo','Malgun Gothic','\uB9D1\uC740 \uACE0\uB515','\uB3CB\uC6C0',Dotum,'\uB3CB\uC6C0\uCCB4' !important;}.drag-handle{", "}div.sendbird-channel-list{", " div.sendbird-channel-list__header{", "}}.sendbird-notification{", "}div.sendbird-conversation{", " .sendbird-conversation__scroll-bottom-button{", " left:50%;bottom:1rem;transform:translateX(-50%);&::before{content:' ';", " background-image:url('/common/icon/ArrowDownwardAlt.svg');background-size:contain;background-repeat:no-repeat;background-position:center;}&::after{content:'\uB9E8 \uC544\uB798\uB85C \uC774\uB3D9';", "}> div{", "}}.sendbird-conversation__messages-padding{overscroll-behavior:contain;padding:0 0.75rem 0 1rem;}}div#sendbird-emoji-list-portal{ul.sendbird-dropdown__reaction-bar{", " z-index:", ";.sendbird-reaction-button:hover,.sendbird-reaction-button--selected:hover{background:", ";}.sendbird-reaction-button--selected{", " background:", ";}}}ul.sendbird-dropdown__menu{", " z-index:", ";li{> span{", "}&:hover,&:active{background:", " !important;}}}div.sendbird-conversation__footer{", " div.sendbird-conversation__footer__typing-indicator{", "}}#sendbird-modal-root{div.sendbird-modal__content{", " div.sendbird-modal__header{", " > span.sendbird-label{", "}>div.sendbird-modal__close{", "}}div.sendbird-modal__footer{", " > button{", " > span.sendbird-button__text{", " span.sendbird-label{", "}}}}}}.sendbird-multiple-files-image-renderer__thumbnail__placeholder,.sendbird-multiple-files-image-renderer__thumbnail__placeholder__icon{", "}"], {
  "cursor": "pointer"
}, {
  "width": "100%"
}, {
  "height": "fit-content"
}, {
  "display": "none"
}, {
  "borderStyle": "none !important"
}, {
  "zIndex": "1",
  "width": "fit-content",
  "borderRadius": "62.4375rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(25 32 41 / var(--tw-border-opacity, 1))",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
}, {
  "marginTop": "0.25rem",
  "height": "1.25rem",
  "width": "1.25rem"
}, {
  "marginLeft": "0.25rem",
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "display": "none"
}, {
  "display": "flex",
  "gap": "0.25rem",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "padding": "0.25rem"
}, CHAT_ROOM_Z_INDEX + 1, getHoveredElementBackground('white'), {
  "borderStyle": "none"
}, getHoveredElementBackground('white'), BasicMenuCss, CHAT_ROOM_Z_INDEX + 1, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, getHoveredElementBackground('var(--gray-100)'), {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "justifyContent": "flex-end",
  "paddingBottom": "0.5rem"
}, {
  "display": "none"
}, {
  "width": "25rem",
  "borderRadius": "0.75rem"
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
}, {
  "fontSize": "1.125rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700"
}, {
  "display": "none"
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
}, {
  "height": "fit-content",
  "flexGrow": "1",
  "borderRadius": "0.5rem",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "1rem",
  "paddingBottom": "1rem"
}, {
  "margin": "0px"
}, {
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "display": "flex !important",
  "height": "100% !important",
  "width": "100% !important",
  "minWidth": "100% !important",
  "alignItems": "center !important",
  "justifyContent": "center !important"
});
export const ChatPopup = styled.article.withConfig({
  componentId: "sc-1u0t0-0"
})(["&{", " top:", ";left:", ";z-index:", ";}"], {
  "position": "fixed"
}, props => props.top ? props.top : 'calc(var(--height-global-nav) + 1rem)', props => props.top ? props.left : `calc(100% - ${CHAT_ROOM_REM_WIDTH}rem - 1rem)`, CHAT_ROOM_Z_INDEX);
export const GroupChannelHeader = styled.div.withConfig({
  componentId: "sc-1u0t0-1"
})(["&{.sendbird-chat-header{", " height:", "rem !important;min-height:", "rem !important;}}"], {
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "paddingLeft": "1.25rem"
}, ChatRoomHeaderRemWidth, ChatRoomHeaderRemWidth);
export const ChatRoomHeaderLayout = styled.div.withConfig({
  componentId: "sc-1u0t0-2"
})(["&{", " ", " height:", "rem;.title{", "}.middle{", "}}"], {
  "boxSizing": "border-box",
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "0.5rem",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "paddingLeft": "1.25rem",
  "paddingRight": "1rem"
}, {
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))"
}, ChatRoomHeaderRemWidth, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "flexGrow": "1",
  "alignItems": "center"
});
export const GroupChannelListFilteringSection = styled.div.withConfig({
  componentId: "sc-1u0t0-3"
})(["&{", " button{", " ", "}button.selected{", "}}"], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "flex-start",
  "gap": "0.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem",
  "borderStyle": "solid"
}, {
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(32 41 57 / var(--tw-text-opacity, 1))"
}, {
  "borderWidth": "2px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(62 126 254 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(235 241 255 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "calc(0.75rem - 1px)",
  "paddingRight": "calc(0.75rem - 1px)",
  "paddingTop": "calc(0.5rem - 1px)",
  "paddingBottom": "calc(0.5rem - 1px)",
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(34 106 250 / var(--tw-text-opacity, 1))"
});
export const PinnedMessageSection = styled.div.withConfig({
  componentId: "sc-1u0t0-4"
})(["&{", " box-shadow:0px 2px 12px 0px color(display-p3 0.098 0.1255 0.1608 / 0.10);> .icon{", "}> .content{", " -webkit-box-orient:vertical;-webkit-line-clamp:2;display:-webkit-box;}> .more-button{", "}}"], {
  "display": "flex",
  "height": "4rem",
  "cursor": "pointer",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem"
}, {
  "display": "flex",
  "height": "100%",
  "alignItems": "flex-start",
  "paddingTop": "0.25rem"
}, {
  "height": "100%",
  "flexGrow": "1",
  "overflow": "hidden",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "position": "relative"
});
export const ChatSeparator = styled.div.withConfig({
  componentId: "sc-1u0t0-5"
})(["&{", "}"], {
  "display": "flex",
  "width": "100%",
  "justifyContent": "center",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
});
const MessageMenuButton = css(["", " width:1.75rem;height:1.75rem;.sendbird-iconbutton__inner{", " .sendbird-message-item-reaction-menu__trigger,.sendbird-iconbutton{", " width:1.75rem !important;height:1.75rem !important;.sendbird-message-item-reaction-menu__trigger__icon,.sendbird-icon-more{", "}button.sendbird-iconbutton{&:hover{background:", ";}}svg{width:22px;height:22px;}}}button.sendbird-iconbutton--pressed{background:", ";}"], {
  "position": "relative",
  "borderRadius": "0.5rem"
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
}, {
  "margin": "0px !important",
  "borderStyle": "none !important",
  "padding": "0px !important"
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
}, getHoveredElementBackground('var(--gray-100)'), getActiveElementBackground('var(--gray-100)'));
export const ChatMessageMenuButton = styled.div.withConfig({
  componentId: "sc-1u0t0-6"
})(["&{", "}"], MessageMenuButton);
export const ChatMessageEmojiMenuButton = styled.div.withConfig({
  componentId: "sc-1u0t0-7"
})(["&{", "}"], MessageMenuButton);
export const ChatMessageEmojiReactionContainer = styled.div.withConfig({
  componentId: "sc-1u0t0-8"
})([".sendbird-emoji-reactions{", " > .sendbird-emoji-reactions__reaction-badge{", " .sendbird-reaction-badge,.sendbird-reaction-badge--selected{", " .sendbird-reaction-badge__inner{", " > .sendbird-reaction-badge__inner__icon{", " > .sendbird-image-renderer{", " > .sendbird-image-renderer__image{", "}}}> .sendbird-reaction-badge__inner__count{", " display:", ";}}}.sendbird-reaction-badge{", "}.sendbird-reaction-badge--selected{", "}> .sendbird-tooltip-wrapper__hover-tooltip{", "}}> .sendbird-context-menu{", "}}.sendbird-emoji-reactions.outgoing{", "}"], {
  "position": "relative",
  "zIndex": "1",
  "display": "flex",
  "gap": "0.25rem",
  "borderStyle": "none !important",
  "paddingLeft": "0px",
  "paddingRight": "0px"
}, {
  "margin": "0px"
}, {
  "display": "flex",
  "height": "1.5rem",
  "width": "fit-content",
  "alignItems": "center",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem"
}, {
  "display": "flex",
  "height": "fit-content",
  "alignItems": "center",
  "gap": "0.25rem",
  "padding": "0px"
}, {
  "position": "relative",
  "left": "0px",
  "top": "0px"
}, {
  "height": "1rem !important",
  "minWidth": "1rem !important"
}, {
  "height": "1rem !important",
  "minWidth": "1rem !important"
}, {
  "marginLeft": "0px",
  "width": "fit-content",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(54 65 82 / var(--tw-text-opacity, 1))"
}, props => props.userType === UserType.STUDENT ? 'none' : 'flex', {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(248 250 252 / var(--tw-bg-opacity, 1))"
}, {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(162 194 255 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(245 249 255 / var(--tw-bg-opacity, 1))"
}, {
  "display": "none",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(236 72 153 / var(--tw-bg-opacity, 1))"
}, {
  "display": "none"
}, {
  "justifyContent": "flex-end"
});
export const ChatGoogleMeetMessageBody = styled.div.withConfig({
  componentId: "sc-1u0t0-9"
})(["&{", " > div:first-child{", " > div:first-child{", "}> div:last-child{", "}}> div:last-child{", "}}"], {
  "width": "15.375rem",
  "cursor": "pointer",
  "overflow": "hidden",
  "borderRadius": "0.75rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 213 220 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(253 242 248 / var(--tw-bg-opacity, 1))"
}, {
  "display": "flex",
  "flexDirection": "column",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(62 126 254 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem"
}, {
  "fontSize": "1.125rem",
  "lineHeight": "1.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))",
  "opacity": "0.6"
}, {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
});
export const ChatMessageProfile = styled.div.withConfig({
  componentId: "sc-1u0t0-10"
})(["&{.sendbird-message-content__left__avatar{", "}}"], {
  "display": "none"
});
export const ChatPhotoMessage = styled.div.withConfig({
  componentId: "sc-1u0t0-11"
})(["&{", "}"], {
  "position": "relative",
  "width": "14rem",
  "maxWidth": "100%",
  "cursor": "pointer",
  "overflow": "hidden",
  "borderRadius": "0.5rem"
});
export const ChatMultiplePhotoMessage = styled.div.withConfig({
  componentId: "sc-1u0t0-12"
})(["&{width:100%;display:flex;flex-wrap:wrap;gap:0.25rem;padding:0.25rem;border-radius:0.75rem !important;cursor:pointer;.image-wrapper{", " min-width:", ";width:", ";flex-grow:1;height:7rem;overflow:hidden;}}"], {
  "position": "relative",
  "cursor": "pointer",
  "overflow": "hidden",
  "borderRadius": "0.5rem"
}, props => `calc((100% - 1rem - ${0.5 * props.multipleFilesGridCount}rem) / ${props.multipleFilesGridCount})`, props => `calc((100% - 1rem - ${0.5 * props.multipleFilesGridCount}rem) / ${props.multipleFilesGridCount})`);
export const ChatSender = styled.div.withConfig({
  componentId: "sc-1u0t0-13"
})(["", ""], {
  "marginBottom": "0.25rem",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
});
export const ChatMessage = styled.div.withConfig({
  componentId: "sc-1u0t0-14"
})([".sendbird-msg-hoc{", " .sendbird-message-hoc__message-content.sendbird-message-content.incoming{", " .sendbird-message-content__left{", "}.sendbird-message-content__middle__body-container{align-items:flex-start;}}.sendbird-message-hoc__message-content.sendbird-message-content.outgoing .sendbird-message-content-reactions{", "}.sendbird-message-content__right{.sendbird-message-content-menu{transform:translateY(-100%);align-items:flex-start;}}.sendbird-message-content__left{.sendbird-message-content-menu{transform:", ";padding-right:0.25rem;padding-bottom:0.25rem;}}.sendbird-message-content__right,.sendbird-message-content__left{padding-bottom:", ";.sendbird-message-content-menu{top:100% !important;}}.sendbird-message-content__middle{width:", ";max-width:", ";.sendbird-message-content__middle__quote-message.outgoing{background-color:", ";}.sendbird-message-content__middle__quote-message.incoming{background-color:", ";}.sendbird-message-content__middle__quote-message{", " width:100%;bottom:0 !important;margin-top:0 !important;.sendbird-message-content__middle__quote-message__quote{", " .sendbird-quote-message__replied-to{", " .sendbird-quote-message__replied-to__icon{", "}.sendbird-quote-message__replied-to__text{", " > span{", "}> span:first-child{", "}> span.sendbird-quote-message__replied-to__text__nickname{", "}> span.sendbird-quote-message__replied-to__text__text::before{content:'", "';}}}.sendbird-quote-message__replied-message{", " .sendbird-quote-message__replied-message__file-message{", " background-image:url(", ");background-repeat:no-repeat;background-size:cover;.sendbird-quote-message__replied-message__file-message__type-icon{", "}}.sendbird-quote-message__replied-message__thumbnail-message{", "}.sendbird-quote-message__replied-message__text-message{", " span{", " overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;}}}}}.sendbird-message-content__middle__body-container{", " .sendbird-message-status__icon{> svg{> path{fill:", ";}}}.sendbird-message-content__middle__body-container__created-at{", " padding-bottom:", ";.sendbird-message-status__icon{", "}.sendbird-message-status__text{", "}}.sendbird-label,.sendbird-og-message-item-body{", " .sendbird-message-content__middle__message-item-body{", " > span.sendbird-text-message-item-body__message.edited{", "}}.outgoing{background-color:", ";", "}.incoming{background-color:", ";}}.sendbird-message-content-reactions{", "}}.sendbird-message-content__middle__quote-message ~ .sendbird-message-content__middle__body-container{> .sendbird-label > .sendbird-message-content__middle__message-item-body{", "}.sendbird-message-content__middle__message-item-body{", "}}}}.sendbird-message-input__edit{.sendbird-message-input--textarea{", "}.sendbird-message-input--edit-action{button{", " > span{", "}}button.sendbird-message-input--edit-action__cancel{", " > span{", "}}button.sendbird-message-input--edit-action__save{> span{", "}}button.sendbird-message-input--edit-action__save.sendbird-button__disabled{", "}}}"], {
  "margin": "0px !important"
}, {
  "marginBottom": "0.25rem"
}, {
  "display": "none"
}, {
  "marginLeft": "auto"
}, props => props.hasReactions ? 'translateY(-200%)' : ' translateY(-100%)', props => props.hasReactions ? '2rem' : '', props => props.messageType === 'multiple-photo' ? '80%' : 'fit-content', props => props.messageType === 'multiple-photo' ? '80%' : '75%', messageBlueColor, props => props.myUserType === UserType.TEACHER && props.senderUserType === UserType.TEACHER ? messageBlueColor : messageGrayColor, {
  "borderTopLeftRadius": "0.75rem",
  "borderTopRightRadius": "0.75rem"
}, {
  "paddingTop": "0.75rem"
}, {
  "padding": "0px"
}, {
  "display": "none"
}, {
  "display": "flex",
  "flexDirection": "row-reverse",
  "paddingLeft": "1rem",
  "paddingRight": "1rem"
}, {
  "margin": "0px",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "display": "none"
}, {
  "display": "none"
}, props => props.counterpartToReply, {
  "width": "100%"
}, {
  "height": "5rem",
  "width": "100%",
  "borderRadius": "0px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(25 32 41 / var(--tw-bg-opacity, 1))",
  "padding": "0px"
}, props => props.parentMessagePhotoThumbnail, {
  "display": "none"
}, {
  "width": "100%"
}, {
  "width": "100%",
  "backgroundColor": "transparent",
  "paddingBottom": "0px",
  "paddingTop": "0.25rem"
}, {
  "display": "flex",
  "maxHeight": "2.7rem",
  "width": "100%",
  "justifyContent": "flex-end",
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "paddingBottom": "0.25rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
}, {
  "width": "100%"
}, props => props.checkIconColor, {
  "width": "fit-content !important",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 101 / var(--tw-text-opacity, 1))"
}, props => props.hasReactions ? '2rem' : '', props => props.myUserType !== UserType.TEACHER && {
  "display": "none"
}, {
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 101 / var(--tw-text-opacity, 1))"
}, {
  "width": "100%",
  "minWidth": "0px"
}, {
  "width": "fit-content",
  "maxWidth": "100%",
  "cursor": "pointer",
  "borderRadius": "0.75rem",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "marginTop": "auto",
  "marginBottom": "auto",
  "marginLeft": "0.25rem",
  "width": "fit-content",
  "textAlign": "center",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
}, messageBlueColor, {
  "display": "flex",
  "justifyContent": "flex-end"
}, props => props.myUserType === UserType.TEACHER && props.senderUserType === UserType.TEACHER ? messageBlueColor : messageGrayColor, {
  "width": "0.25rem",
  "backgroundColor": "transparent",
  "paddingBottom": "0px"
}, {
  "width": "100%"
}, {
  "borderTopLeftRadius": "0",
  "borderTopRightRadius": "0",
  "paddingTop": "0.25rem"
}, {
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(25 32 41 / var(--tw-border-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500"
}, {
  "width": "fit-content",
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(34 106 250 / var(--tw-border-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem"
}, {
  "margin": "0px",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "700"
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(34 106 250 / var(--tw-text-opacity, 1))"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "--tw-border-opacity": "1",
  "borderColor": "rgb(210 226 255 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(210 226 255 / var(--tw-bg-opacity, 1))"
});